import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const session_id = m[1];
    // clear hash
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const r = await api.post("/auth/google-session", { session_id });
        setUser(r.data.user);
        const role = r.data.user.role;
        if (role === "customer") navigate("/portal");
        else navigate("/dashboard");
      } catch (e) {
        const msg = e?.response?.data?.detail || "Sign-in failed";
        navigate("/?error=" + encodeURIComponent(msg));
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div data-testid="auth-callback-loading" className="text-muted-foreground font-heading">Finishing sign-in…</div>
    </div>
  );
}
